import { TableColumn } from '@shared';

export const TABLE_COLUMNS: TableColumn[] = [
    { field: 'thumbnail', header: 'Thumbnail', width: '100px', type: 'image' },
    { field: 'name', header: 'Name', width: '250px', hasRedirect: true },
    { field: 'type', header: 'Type', width: '100px' },
    { field: 'size', header: 'Size', width: '100px' },
    { field: 'duration', header: 'Duration', width: '100px' },
    { field: 'dateCreated', header: 'Date Created', width: '150px' },
];
